import Header from "./Header/Header";
import Footer from "./Footer/Footer";

const PublicLayout = ({ children }) => {
  return (
    <div className="portal-page">
      <Header />

      <main className="ynb-main">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default PublicLayout;
